import { LoaderFunctionArgs, redirect } from "react-router"
import { WalletState } from "../../domain/ethereum/Models/WalletState"

export const authLoader = async ({ request }: LoaderFunctionArgs) => {
  const walletState = await window.domain.GetWalletStateEthereumUseCase.execute()
  const { pathname } = new URL(request.url)

  if (walletState.status !== WalletState.STATUS.CONNECTED)
    return redirect(`/connect?redirectTo=${encodeURIComponent(pathname)}`)

  return null
}
